export const CLIENT = "Client";
export const SHAREHOLDER = "Shareholder";
export const ADMINISTRATOR = "Administrator";
export const GUARANTOR = "Guarantor";
